import clsx from "clsx";

import PlanFeatureList from "./PlanFeatureList";

import type { ReactNode } from "react";

interface PlanSettingsLeftPanelProps {
  icon: ReactNode;
  title: string;
  features: string[];
  action?: ReactNode;
  tags?: ReactNode;
}

export default function PlanSettingsLeftPanel({
  icon,
  title,
  features,
  action,
  tags,
}: PlanSettingsLeftPanelProps) {
  return (
    <div className={clsx("flex flex-col gap-6 p-5", tags && "justify-between")}>
      <div className="flex flex-row items-center justify-between gap-3">
        <div className="flex flex-row items-center gap-3">
          {icon}
          <span className="text-lg-bold">{title}</span>
        </div>

        {tags && <div className="flex flex-row items-center gap-2">{tags}</div>}
      </div>

      <PlanFeatureList features={features} />

      {action && <div className="flex justify-end">{action}</div>}
    </div>
  );
}
